import { kmsClient } from 'api';
import { useMutation } from '@apollo/react-hooks';
import { FRESH_ARTICLE_AUDIENCES_MUTATION } from './freshArticleAudiences.mutation';
import { FreshArticleAudiences, FreshArticleAudiencesVariables } from './__generated__/FreshArticleAudiences';

export const useFreshArticlesAudiences = () => {
  return useMutation<FreshArticleAudiences, FreshArticleAudiencesVariables>(FRESH_ARTICLE_AUDIENCES_MUTATION, {
    client: kmsClient
  });
};
